import { UnsubscribeViewComponent } from '@app/mailing';
import { Routes } from "@angular/router";

export const mailingModuleRoutes: Routes = [{
  path: 'mailing',
  children: [
    {
      path: 'unsubscribe',
      component: UnsubscribeViewComponent
    },
    { path: '**', redirectTo: '/', pathMatch: 'full' }
  ]
}];
